/**
 * @generated SignedSource<<ab3fbea7e1d6a3e0f73a1648b027946c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type SchoolExamSourceHistoryFilter = {
  AND?: SchoolExamSourceHistoryFilter | null;
  DISTINCT?: boolean | null;
  NOT?: SchoolExamSourceHistoryFilter | null;
  OR?: SchoolExamSourceHistoryFilter | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  schoolExamSourceId_In?: ReadonlyArray<string> | null;
};
export type SchoolExamSourceHistoryOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
};
export type SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery$variables = {
  after?: string | null;
  filters?: SchoolExamSourceHistoryFilter | null;
  first?: number | null;
  id: string;
  order?: SchoolExamSourceHistoryOrder | null;
};
export type SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource">;
  };
};
export type SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery = {
  response: SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery$data;
  variables: SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": {
    "created": "DESC"
  },
  "kind": "LocalArgument",
  "name": "order"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "SchoolExamSourceHistoryConnection",
                "kind": "LinkedField",
                "name": "histories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchoolExamSourceHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchoolExamSourceHistory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "picture",
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDeleted",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "created",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "difference",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isDifference"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "scrapImages",
                                    "plural": true,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "SchoolExamSourcePublishDifference",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "innerPdf",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "SchoolExamSourceUploadDifference",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": [
                  "filters",
                  "order"
                ],
                "handle": "connection",
                "key": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_histories",
                "kind": "LinkedHandle",
                "name": "histories"
              }
            ],
            "type": "SchoolExamSource",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b5ec9456f896ac89c4a7bd6efe452973",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery",
    "operationKind": "query",
    "text": "query SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery(\n  $after: String\n  $filters: SchoolExamSourceHistoryFilter\n  $first: Int = 10\n  $order: SchoolExamSourceHistoryOrder = {created: DESC}\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_2rfEMg\n    id\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment SchoolExamSourceHistoryDialog_SchoolExamSourceHistory on SchoolExamSourceHistory {\n  id\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...SchoolExamSourcePublishDifferenceCounterLabel_difference\n    ...SchoolExamSourcePublishDifferenceItemList_difference\n    ...SchoolExamSourceUploadDifferenceCounterLabel_difference\n    ...SchoolExamSourceUploadDifferenceItemList_difference\n  }\n}\n\nfragment SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory on SchoolExamSourceHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment SchoolExamSourcePublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourcePublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_2rfEMg on SchoolExamSource {\n  histories(filters: $filters, order: $order, first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...SchoolExamSourceHistoryDialog_SchoolExamSourceHistory\n        ...SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment SchoolExamSourceUploadDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourceUploadDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "7daacbeb661dc9d84e110ed3eb00387d";

export default node;
